import React from 'react';
import { Link } from 'gatsby';
import cn from 'classnames';
import Logo from '../images/iconText.png';

const Navigation = ({ location }) => {
  const homePage = location.pathname === '' || location.pathname === '/';
  const employersPage = location.pathname.startsWith('/arbetsgivare');
  const aboutPage = location.pathname.startsWith('/om');
  return (
    <div
      className={cn('flex flex-col lg:flex-row justify-between items-center lg:px-32 py-3 lg:py-2 absolute top-0 left-0 w-full z-10 overflow-hidden', { 'bg-primary': aboutPage || employersPage })}>
      <Link to='/' className='text-4xl font-semibold h-24 fill-current'>
        <img src={Logo} alt='Logo' className='h-full' />
        <span className='sr-only'>Juridicas</span>
      </Link>
      <div
        className='flex text-xl justify-center items-center mt-2 lg:mt-0 relative space-x-4 lg:space-x-12 transition-colors duration-150 text-center'>
        <Link to='/'
              className={cn('underlined-link', {
                'after:w-0 after:left-1/2': !homePage,
                'after:w-full after:left-0': homePage
              })}>
          Hem
        </Link>
        <Link to='/arbetsgivare'
              className={cn('underlined-link', {
                'after:w-0 after:left-1/2': !employersPage,
                'after:w-full after:left-0': employersPage
              })}>
          För arbetsgivare
        </Link>
        <Link to='/om'
              className={cn('underlined-link', {
                'after:w-0 after:left-1/2': !aboutPage,
                'after:w-full after:left-0': aboutPage
              })}
        >
          Om oss
        </Link>
      </div>
    </div>
  );
};

export default Navigation;